var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useEffect, useRef, useState } from 'react';
import { Send, Loader2, Check, Clock, AlertCircle } from 'lucide-react';
import { Button } from 'components/ui/button';
import { cn } from 'lib/utils';
import nudgeProducer from 'actions/nudgeProducerApi';
import { nudgeButtonView } from './nudgeButtonView';
var ICONS = {
    idle: _jsx(Send, { "aria-hidden": true }),
    sending: _jsx(Loader2, { className: "animate-spin", "aria-hidden": true }),
    sent: _jsx(Check, { "aria-hidden": true }),
    rate_limited: _jsx(Clock, { "aria-hidden": true }),
    error: _jsx(AlertCircle, { "aria-hidden": true })
};
// How long a terminal-but-transient state lingers before reverting to idle.
var SENT_REVERT_MS = 2500;
var RATE_LIMIT_REVERT_MS = 4000;
/**
 * Coach one-tap "Nudge" button (SCO-384 / V0 T16). Lives on the per-producer
 * card; calls the Node coach-nudge route and reflects the outcome inline. `sent`
 * and `rate_limited` auto-revert to `idle` so the button stays reusable; `error`
 * stays actionable for an immediate retry. Tailwind + shadcn per the styling
 * rule. Gated by the NUDGE_BUTTON flag at the call site.
 */
export default function NudgeButton(_a) {
    var _this = this;
    var producerId = _a.producerId, producerName = _a.producerName, className = _a.className;
    var _b = useState('idle'), state = _b[0], setState = _b[1];
    var mounted = useRef(true);
    var revertTimer = useRef(undefined);
    useEffect(function () { return function () {
        mounted.current = false;
        if (revertTimer.current)
            window.clearTimeout(revertTimer.current);
    }; }, []);
    var revertLater = function (ms) {
        revertTimer.current = window.setTimeout(function () {
            if (mounted.current)
                setState('idle');
        }, ms);
    };
    var _c = nudgeButtonView(state), label = _c.label, disabled = _c.disabled;
    var handleClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (disabled)
                        return [2 /*return*/];
                    setState('sending');
                    return [4 /*yield*/, nudgeProducer(producerId)];
                case 1:
                    result = _a.sent();
                    if (!mounted.current)
                        return [2 /*return*/];
                    if (result.status === 'sent') {
                        setState('sent');
                        revertLater(SENT_REVERT_MS);
                    }
                    else if (result.status === 'rate_limited') {
                        setState('rate_limited');
                        revertLater(RATE_LIMIT_REVERT_MS);
                    }
                    else {
                        setState('error');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Button, { type: "button", variant: "outline", size: "sm", disabled: disabled, onClick: handleClick, "aria-label": producerName ? "".concat(label, " ").concat(producerName) : label, 
        // align-middle: the host `sb-expectations-header` is inline-flow (legacy
        // CSS), so keep the button vertically centred against the baseline title.
        className: cn('ml-2 align-middle', className), children: [ICONS[state], label] }));
}
